/* eslint-disable camelcase */
export default async function resetPasswordFromEmail(
  uid: string,
  token: string,
  new_password1: string,
  new_password2: string
) {
  const response = await fetch(`/auth/password/reset/confirm/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ uid, token, new_password1, new_password2 }),
  });

  const data = await response.json();
  return { success: response.ok, ...data };
}
/* eslint-enable camelcase */
